const Images = [
    {
        id: 1,
        cover: '../canvy/Bright_modern_kitchen_interior.jpg',
        alt: 'Image 1',
        title: 'Vague',
        hovered: '../images/vague.jpg',
    },
    {
        id: 2,
        cover: '../canvy/Bright_studio_apartment_living_room.jpg',
        alt: 'Image 2 ',
        title: 'Paysage marin',
        hovered: '../images/mer.jpg',
    },
    {
        id: 3,
        cover: '../canvy/Dining_area_with_wooden_furniture.jpg',
        alt: 'Image 3',
        title: 'Ponton',
        hovered: '../images/ponton.jpg',
    },
    {
        id: 4,
        cover: '../canvy/Scandinavian_dining_room.jpg',
        alt: 'Image 4',
        title: 'Bouddha',
        hovered: '../images/buddha.jpg',
    },
    {
        id: 5,
        cover: '../canvy/The_kids_playroom.jpg',
        alt: 'Image 5',
        title: 'Petit oiseau',
        hovered: '../images/oiseau.jpg',
    },
    {
        id: 6,
        cover: '../canvy/Comfy_bedroom_with_side_tables_and_lamps.jpg',
        alt: 'Image 6',
        title: 'Jour et Nuit',
        hovered: '../images/arbre_jour_nuit.jpg',
    },
]

export default Images
